import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

type FetchCommunities = () => Request.RequestAction
export const fetchCommunities: FetchCommunities =
  () =>
    Request.requestActionCreator(Constants.FETCH_COMMUNITIES)
    ({url: '/communities', method: 'GET'})

type FetchCommunityConfigActionCreator = (communityIdentifier: Types.CommunityIdentifier) =>
  Types.FetchCommunityConfigAction
export const fetchCommunityConfig: FetchCommunityConfigActionCreator =
  (communityIdentifier: Types.CommunityIdentifier) =>
    Request.requestActionCreator<Types.FetchCommunityConfigPayload>(Constants.FETCH_COMMUNITY_CONFIG)
    ({
      communityIdentifier,
      method: 'GET',
      url: `/communities/${communityIdentifier}/config`,
    })

interface ConfigPayload {
  configId: string,
  id: number,
  key: string,
  partner_code: string,
  value: string,
}

const configPayload = (configRow: Types.ConfigRow): ConfigPayload => {
  return {
    configId: configRow.id,
    id: configRow.community_configuration_id,
    key: configRow.key,
    partner_code: configRow.partner_code,
    value: configRow.value,
  }
}

export const addCommunityConfig =
  (communityIdentifier: Types.SelectedCommunity, configRow: Types.ConfigRow) =>
    Request.requestActionCreator(Constants.ADD_CONFIG)
    ({
      method: 'POST',
      payload: configPayload(configRow),
      url: `/communities/${communityIdentifier}/config`,
    })

export const updateCommunityConfig =
  (communityIdentifier: Types.SelectedCommunity, configRow: Types.ConfigRow) =>
      Request.requestActionCreator(Constants.UPDATE_CONFIG)
      ({
        method: 'PUT',
        payload: configPayload(configRow),
        url: `/communities/${communityIdentifier}/config/${configRow.community_configuration_id}`,
      })

export const deleteCommunityConfig =
  (communityIdentifier: Types.SelectedCommunity, configRow: Types.ConfigRow) =>
    Request.requestActionCreator(Constants.DELETE_CONFIG)
    ({
      method: 'DELETE',
      payload: configPayload(configRow),
      url: `/communities/${communityIdentifier}/config/${configRow.community_configuration_id}`,
    })

export type UpdateSearchAction = (searchTerm: string) => any
export const updateSearch: UpdateSearchAction = (searchTerm: string) => ({
  term: searchTerm,
  type: Constants.UPDATE_SEARCH_STRING,
})

export const closeModal = () => ({ type: Modal.closeModalConstant(Constants.UPLOAD_IMAGE) })
export const updateLogoModalField = (field: Modal.ModalField) =>
  ({ type: Modal.updateModalConstant(Constants.UPLOAD_IMAGE), field })



// WEBPACK FOOTER //
// ./src/pages/community-config/actions.ts